import React from 'react';

import PagesIcon from '@material-ui/icons/Pages';

import {
  PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR,
  PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR,
  PERMISSAO_TELA_COTACOES_LISTAR,
  PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR,
  PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR,
  PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuComprador = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Comprador"
    icon={<PagesIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR] &&
      hasResource('configuracoes_produtos')}
    {permissoes[PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR] &&
      hasResource('bancos_fornecedores')}
    {permissoes[PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR] &&
      hasResource('funcoes_funcionarios_fornecedores')}
    {permissoes[PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR] &&
      hasResource('jornais_de_ofertas')}
    {permissoes[PERMISSAO_TELA_COTACOES_LISTAR] &&
      hasResource('cotacoes_templates')}
    {permissoes[PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR] &&
      hasResource('ofertas_de_zerar_estoque')}
    {permissoes[PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR] &&
      hasResource('pedidos-compras')}
    {permissoes[PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR] &&
      hasResource('representantes-fornecedores')}
    {permissoes[PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR] &&
      hasResource('agendamento-compra-fornecedores')}
  </SubMenu>
);

export default SubMenuComprador;
